<template>
  <MainLayout>
    <AppBreadcrumb
      title="500 Server Error"
      :items="[
        { text: 'ပင်မစာမျက်နှာ', to: { name: 'homeIndex' } },
        { text: 'ဆာဗာချို့ယွင်းချက်' }
      ]"
    />
    <section class="sec-wrap sec-error-wrap">
      <div class="cmn-card-no-border error-card">
        <div class="icon-frame icon-server-frame">
          <app-icon name="server" size="48" class="server-icon" aria-hidden="true" />
          <span class="badge badge-500 en">500</span>
        </div>
        <div class="content-group">
          <h2 class="title">ဆာဗာချို့ယွင်းချက်</h2>
          <p class="description">
            တောင်းပန်ပါတယ်။ စနစ်ပိုင်းဆိုင်ရာ အခက်အခဲတစ်ခု ဖြစ်ပွားနေသဖြင့် စာမျက်နှာကို ဝန်ဆောင်မှုမပေးနိုင်သေးပါ။ ခဏအကြာမှ ပြန်လည် ကြိုးစားပေးပါရန် မေတ္တာရပ်ခံအပ်ပါသည်။
          </p>
        </div>
        <div class="btn-container">
          <router-link :to="homeRoute" class="btn btn-back">
            ပင်မစာမျက်နှာ
          </router-link>
        </div>
        <div class="contact-us-container">
          မေးမြန်းလိုသည်များရှိပါက <router-link :to="{ name: 'contactUsNew' }" class="green-txt">ဆက်သွယ်ရန်</router-link>ကို နှိပ်ပြီး မေးမြန်းနိုင်ပါသည်။
        </div>
      </div>
    </section>
  </MainLayout>
</template>

<script>
import MainLayout from "@/components/layout/applicant/MainLayout.vue";
export default {
  name: "internalServerError",
  components: {
    MainLayout
  },
  data() {
    return {
      homeRoute: { name: 'homeIndex' }
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to.path.startsWith('/company')) {
        vm.homeRoute = { name: 'companyIndex' };
      } else if (to.path.startsWith('/admin')) {
        vm.homeRoute = { name: 'adminIndex' };
      } else if (from && from.path) {
        if (from.path.startsWith('/company')) {
          vm.homeRoute = { name: 'companyIndex' };
        } else if (from.path.startsWith('/admin')) {
          vm.homeRoute = { name: 'adminIndex' };
        }
      }
    });
  }
};
</script>